import { render } from "./RefBiblioList.vue?vue&type=template&id=421dd532&scoped=true"
import script from "./RefBiblioList.vue?vue&type=script&lang=js"
export * from "./RefBiblioList.vue?vue&type=script&lang=js"

import "./RefBiblioList.vue?vue&type=style&index=0&id=421dd532&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-421dd532"]])

export default __exports__